export default {
    thumbnailsLeft: {
        primary: {
            type: 'fade',
            perPage: 1,
            perMove: 1,
            heightRatio: 1,
            pagination: false,
            arrows: false,
            cover: true,
            throttle: 200,
        },
        secondary: {
            type: 'slide',
            direction: 'ttb',
            fixedWidth: '100px',
            fixedHeight: '100px',
            height: '330px',
            perPage: 3,
            perMove: 1,
            arrows: true,
            rewind: false,
            isNavigation: true,
            gap: 10,
            focus: 'top',
            pagination: false,
            cover: true,
            throttle: 200,
            breakpoints: {
                600: {
                    fixedWidth: 66,
                    fixedHeight: 66,
                },
            },
        },
    },
    thumbnailsBottom: {
        primary: {
            type: 'fade',
            perPage: 1,
            perMove: 1,
            pagination: false,
            arrows: false,
            cover: true,
            throttle: 200,
        },
        secondary: {
            type: 'slide',
            fixedHeight: '100px',
            fixedWidth: '100px',
            width: '450px',
            perPage: 3,
            perMove: 1,
            arrows: true,
            rewind: false,
            isNavigation: true,
            gap: 10,
            focus: 'top',
            pagination: false,
            cover: true,
            throttle: 200,
            breakpoints: {
                600: {
                    fixedWidth: 66,
                    fixedHeight: 66,
                },
            },
        },
    },
    simple: {
        primary: {
            type: 'slide',
            perPage: 1,
            perMove: 1,
            pagination: true,
            arrows: true,
            throttle: 200,
        },
    },
    productsSlider: {
        type: 'slide',
        perPage: 2,
        perMove: 1,
        pagination: true,
        arrows: true,
        throttle: 200,
        breakpoints: {
            600: {
                perPage: 1,
            },
        },
    },
}
